import React, { useState } from 'react';
import { getMonthOptions } from '../../utils/invoiceFormatters';

const GenerateAllModal = ({ onClose, onConfirm }) => {
  const monthOptions = getMonthOptions();
  // Default to previous month
  const defaultOption = monthOptions[1] || monthOptions[0];
  const [selectedValue, setSelectedValue] = useState(defaultOption?.value || '');
  const [loading, setLoading] = useState(false);

  const selected = monthOptions.find(o => o.value === selectedValue) || defaultOption;

  const handleConfirm = async () => {
    if (!selected) return;
    setLoading(true);
    try {
      await onConfirm(selected.month, selected.year);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl w-full max-w-md shadow-xl">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-800">Generate All Billing</h2>
          <button onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl leading-none">&times;</button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              Billing Period
            </label>
            <select
              value={selectedValue}
              onChange={e => setSelectedValue(e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary/30">
              {monthOptions.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>

          <div className="bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 text-sm text-amber-800">
            <p className="font-medium mb-1">⚠ Important</p>
            <p>This will generate invoices for all active enterprises for the selected month.
              Enterprises that already have a non-DRAFT invoice will be skipped automatically.</p>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-100 flex items-center justify-end gap-3">
          <button onClick={onClose} disabled={loading}
            className="px-4 py-2 text-sm text-gray-600 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50">
            Cancel
          </button>
          <button onClick={handleConfirm} disabled={loading}
            className="px-5 py-2 text-sm bg-primary text-white rounded-lg hover:bg-primary-light transition-colors disabled:opacity-50 flex items-center gap-2">
            {loading ? (
              <>
                <span className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Triggering...
              </>
            ) : (
              'Confirm & Generate'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GenerateAllModal;
